import * as Yup from 'yup';
import { PhoneNumberUtil } from 'google-libphonenumber';

/**
 * Remove any non numeric characters from the phone number but leave any plus sign at the beginning
 * phone (String) phone number to clean
 * @param phone Phone number
 */
function cleanPhone(phone: string) {
  let cleanedNumber = phone.replace(/[^\d+]/g, '');
  if (cleanedNumber.substr(0, 1) === '+') {
    cleanedNumber = '+' + cleanedNumber.replace(/[^\d]/g, '');
  } else {
    cleanedNumber = cleanedNumber.replace(/[^\d]/g, '');
  }
  return cleanedNumber;
}

/**
 * Tests whether a phone number matches a valid pattern. Note this doesn't
 * verify the number is actually in use, which is impossible to tell by just
 * looking at a number itself.
 *
 * @param phone  Phone number
 * @param country Country code (eg. US)
 */
function isValidNumberNotRequiredIfEmpty(phone: string, country: string) {
  if (phone === undefined) return true;

  try {
    const phoneArr = phone.split(/,+|\s+|\n+/).filter((elem) => elem.length);
    if (phoneArr.length > 1) {
      return phoneArr.every((phone) =>
        isValidNumberNotRequiredIfEmpty(phone, country)
      );
    }
    const cleanedNumber = cleanPhone(phone);
    const phoneUtil = PhoneNumberUtil.getInstance();
    const number = phoneUtil.parseAndKeepRawInput(cleanedNumber, country);
    return phoneUtil.isValidNumber(number);
  } catch (e) {
    return false;
  }
}

function isValidNumberForYup(
  // eslint-disable-next-line @typescript-eslint/ban-types
  this: Yup.StringSchema<string | undefined, object>, // define type in typescript
  message: string
) {
  return this.test('is-valid-foward-number', message, async function (
    forwardNumber: any
  ): Promise<any> {
    const { path, createError, resolve } = this;

    const countrycode = resolve(Yup.ref('countrycode'));
    // return true if all emails are valid or error if one is false
    return (
      isValidNumberNotRequiredIfEmpty(forwardNumber, countrycode) ||
      createError({
        path,
        message,
      })
    );
  });
}

/**
 * Write custom validator for Yup checking for comma separated emails
 *
 * @example
 *  import '../../../../../common/formik-material-ui/isValidNumber';
 *
 *  const QueueEditSchema = Yup.object({
 *    submitQueueEditPayload: Yup.object({
 *      email: Yup.string().isValidNumber('Invalid email'),
 *    }),
 *  });
 */
Yup.addMethod<Yup.StringSchema>(
  Yup.string,
  'isValidNumberNotRequiredIfEmpty',
  isValidNumberForYup
);
